export default __webpack_public_path__ + "static/media/white-arrow.524c18e9.svg";